import { Controller } from "@hotwired/stimulus";

// Shows a live "N contacts selected" count for a checkbox group.
// Connect to a container; mark each checkbox as a "checkbox" target with
// `change->selection-count#update`, and an element as the "output" target.
// Override the counted noun via data-selection-count-noun-value.
export default class extends Controller {
  static targets = ["checkbox", "output"];
  static values = { noun: { type: String, default: "contact" } };

  connect() {
    this.update();
  }

  update() {
    const count = this.checkboxTargets.filter((cb) => cb.checked).length;
    const noun = count === 1 ? this.nounValue : `${this.nounValue}s`;
    this.outputTarget.textContent = `${count} ${noun} selected`;
  }
}
